module.exports = __webpack_public_path__ + "enterprise-app-ui-design.3Bkhnama.svg";